/* eslint-disable max-len */

export const DESCRIPTION = {
  USSD_SESSION:
    'Access to USSD channel allows developers to create USSD applications by implementing Qrios USSD API or/and using Qrios USSD Editor.',
  USSD_PUSH:
    'Access to USSD Push functionality allows developers to initiate USSD push session. In contrast to the USSD string dialed by the user, the USSD push session is initiated from the application side - the customer will receive a USSD message without his interaction.',
  SMS: 'SMS is an operation provided by Qrios API to send SMSes.',
  OPERATOR_LOOKUP:
    'Operator Lookup operation is an operation provided by Qrios API for developers to query the operator of a given phone number.',
  AIRTIME_AND_DATA:
    'Top-up & Data is an operation provided by Qrios API for developers to buy top-up or data products.',
  TRANSFER:
    'Transfer is an operation provided by Qrios API for developers to initiate bank-to-bank transfers (with PIN verification in USSD channel).',
  ON_DEMAND:
    'Ondemand Payment & Acquisition is an operation provided by Qrios API for developers to buy Ondemands products.',
  PAYOUT:
    'Payout is an operation that transfers funds from the developers virtual purse to a credit account passed in a payout request.',
  MERCHANT_PAYMENT:
    'Merchant Payment is an operation provided by Qrios API for developers to initiate the merchant payment process with confirmation by the sender in the USSD channel.',
  CUSTOMER_AUTHENTICATION:
    'Customer authentication is an operation provided by Qrios API for developers to authenticate customers identified by phone number.',
  CUSTOMER_ENROLLMENT:
    'Customer enrollment is an operation provided by Qrios API for developers to enroll customers identified by phone number in external services.',
  CUSTOMER_VALIDATION:
    'KYC (Customer Validation) is an operation provided by Qrios API for developers to check if a customers personal data is correct.'
};
